<template>
    <v-container fill-height fluid grid-list-xl>
        <v-layout wrap>
            <v-flex sm12 xs12 md12 lg12 grid-list-md>
                <material-card icon="mdi-content-copy" :title="title" :text="text">       
                    <v-toolbar flat color="white">
                        <v-spacer></v-spacer>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn class="mb-2" rounded small fab v-on="on" to="/controle-acesso/usuario/adicionar">
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>                                
                            </template>

                            <span>{{add}}</span>
                        </v-tooltip> 
                    </v-toolbar>


                    <!-- <v-data-table :headers="colunas" :items="tableItens" class="elevation-1" :footer-props="dataFooter">
                        <template v-slot:[`item.addDate`]="{ item }">
                            {{formatUtcToLocal(item.addDate)}}                              
                        </template>  

                        <template v-slot:[`item.acoes`]="{ item }">
                            <router-link :to="`/controle-acesso/Usuario/editar/${item.id}`" class="action">        
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-icon small class="mr-2" v-on="on">
                                            mdi-pencil
                                        </v-icon>        
                                    </template>
                                </v-tooltip>                           
                            </router-link>                               
                        </template>                           

                        <template v-slot:no-data>{{nenhumUsuarioEncontrado}}</template>
                    </v-data-table>                                                                        -->
                </material-card>
            </v-flex>
        </v-layout>   
    </v-container>
</template>

<script>
import FormMixin from '@/mixin/form'
import DateMixin from '@/mixin/date'

import UserMixin from './mixin'
import ApiUser from '@/api/identityProvider/user'

export default {
    mixins: [ FormMixin, DateMixin, UserMixin ],  
    data () {
        return { 
            exibirDetalhes: false,
            colunas: [
                { text: this.$t('Views.ControleAcesso.Usuario.Listar.identificador'), align: 'right', value: 'id' },
                { text: this.$t('Views.ControleAcesso.Usuario.Listar.codigo-unico'), align: 'center', value: 'uniqueCode' },
                { text: this.$t("Views.ControleAcesso.Usuario.Listar.descricao"), align: 'left', value: 'description' },  
                { text: this.$t('Views.ControleAcesso.Usuario.Listar.data-cadastro'), align: 'center', value: 'addDate' },                              
                { value: 'acoes', sortable: false },
            ]                
        }
    },
    computed: {            
        text () {
            return this.$t('Views.ControleAcesso.Usuario.Listar.form-text');            
        },     
        tableItens(){
            if(this.lista.User == null || this.lista.User == undefined)
                return [];

            return this.lista.User;
        },
        nenhumUsuarioEncontrado(){
            return this.$t('Views.ControleAcesso.Usuario.Listar.nenhuma-Usuario-encontrada');            
        }
    },
    async created(){
        this.formUniqueCode = "FORM.COAC.00001";
        this.UserUniqueCode = "SELC";

        ///this.$set(this.showItem, "insert", await this.hasAccess(this.formUniqueCode, "INSE"));
    },    
    async mounted(){
        // const loading = this.showLoading();
        // await this.listar();
        // loading.close();
    },
    methods:{
        async listar(){
            const resultado = await ApiUser.listar().catch(erro => this.showSnackbarError(erro.error));
            if(resultado.success){
                this.$set(this.lista, "User", resultado.data);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/material-dashboard/variables";

</style>
